Ext.define('Simplymap.view.PagingToolbar', {
    alias: 'widget.sa-paging-toolbar',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-paging-toolbar',
    page: 0,
    pageCount: 0,

    initComponent() {
        this.items = [
            {
                xtype: 'sa-button',
                cls: 'sa-paging-toolbar-first-button',
                icon: 'sa-icon-paging-first',
                itemId: 'firstBtn',

                handler: () => {
                    this.setPage(1);
                }
            }, {
                xtype: 'sa-button',
                cls: 'sa-paging-toolbar-previous-button',
                icon: 'sa-icon-paging-previous',
                itemId: 'previousBtn',

                handler: () => {
                    this.setPage(this.page - 1);
                }
            }, {
                xtype: 'component',
                cls: 'sa-paging-toolbar-text',
                html: 'Page'
            }, {
                xtype: 'sa-numberfield',
                allowDecimals: false,
                enableKeyEvents: true,
                height: 20,
                keyNavEnabled: false,
                minValue: 1,
                selectOnFocus: true,
                width: 40,

                listeners: {
                    blur: field => {
                        this.setPage(field.getValue());

                        field.setValue(this.page);
                    },

                    keydown: (field, ev) => {
                        var increment = 1;

                        switch (ev.getKey()) {
                            case ev.RETURN:
                                increment = 0;

                            case ev.DOWN:
                            case ev.PAGE_DOWN:
                                increment *= -1;

                            case ev.UP:
                            case ev.PAGE_UP:
                                this.setPage(field.getValue() + increment);

                            case ev.ESC:
                                ev.stopEvent();

                                field.setValue(this.page);
                            break;
                        }
                    }
                }
            }, {
                xtype: 'component',
                cls: 'sa-paging-toolbar-text',
                itemId: 'pageCount'
            }, {
                xtype: 'sa-button',
                cls: 'sa-paging-toolbar-next-button',
                icon: 'sa-icon-paging-next',
                itemId: 'nextBtn',

                handler: () => {
                    this.setPage(this.page + 1);
                }
            }, {
                xtype: 'sa-button',
                cls: 'sa-paging-toolbar-last-button',
                icon: 'sa-icon-paging-last',
                itemId: 'lastBtn',

                handler: () => {
                    this.setPage(this.pageCount);
                }
            }
        ];

        this.callParent();

        this.pageField = this.down('sa-numberfield');
        this.pageCountText = this.down('#pageCount');
        this.firstBtn = this.down('#firstBtn');
        this.previousBtn = this.down('#previousBtn');
        this.nextBtn = this.down('#nextBtn');
        this.lastBtn = this.down('#lastBtn');

        this.refresh();
    },

    getPage() {
        return this.page;
    },

    refresh() {
        var page = this.page,
            pageCount = this.pageCount,
            pageField = this.pageField;

        Ext.suspendLayouts();

        this.pageCountText.update('of ' + pageCount);

        pageField.setDisabled(!pageCount);

        pageField.setValue(page);

        this.firstBtn.setDisabled(page < 2);
        this.previousBtn.setDisabled(page < 2);
        this.nextBtn.setDisabled(page >= pageCount);
        this.lastBtn.setDisabled(page >= pageCount);

        Ext.resumeLayouts(true);
    },

    setPage(page) {
        var pageCount = this.pageCount;

        page = Ext.Number.constrain(+page || 0, pageCount ? 1 : 0, pageCount);

        if (this.page !== page) {
            this.page = page;

            this.refresh();

            this.fireEvent('change:page', this);
        }
    },

    setPageCount(pageCount) {
        var oldPage = this.page,
            page = oldPage || 1;

        if (this.pageCount !== pageCount) {
            this.pageCount = pageCount;

            if (page > pageCount) {
                page = pageCount;
            }

            this.pageField.setMaxValue(pageCount);

            if (page !== oldPage) {
                this.setPage(page);
            }
            else {
                this.refresh();
            }
        }
    }
});